// 配额模块
export default {
    Quota: {
        Quota: 'Kwota',
        AddQuotaOptions: 'Tambah pilihan kuota',
        Name: 'Nama',
        deleteIt: 'Adakah anda pasti untuk memadamnya?',
        RuleType: 'Jenis Peraturan',
        DisplayQuota: 'Papar kuota',
        HideQuota: 'Sembunyi Quota',
        QuotaNumber: 'Nombor kvot',
        CompleteNumber: 'Kuantiti selesai',
        RuleName: 'Nama Peraturan',
        DisplayQuotaTip: '(Semasa proses menjawab, semak kuota, yang sudah penuh dan tidak dapat dipilih)',
        QuotaFullTip: 'Salin maklumat penuh Quota',
        QuotaFullPlaceholder: 'Quota penuh (sehingga sepuluh perkataan)',
        HideQuotaTip: '(Semak kuota selepas menghantar helaian jawapan, dan tandakannya secara automatik sebagai tidak sah jika kuota penuh)',
        RuleCondition1: 'Keadaan peraturan 1',
        PleaseSelect: 'Sila pilih',
        AddConditions: 'Tambah syarat',
        RuleCondition2: 'Kondisi Peraturan 2',
        QuotaDetails: 'Perincian Quota',
        NotSetTotalQuota: '(Boleh dibiarkan kosong, lalai untuk tidak menetapkan jumlah kuota)',
        FillDown: 'Isi',
        QuotaQuantity: 'Kuantiti kvot',
        ModifyQuotaCount: 'Ubah Kiraan Quota',
        PleaseEnterModifyQuotaCount: 'Sila masukkan nilai kuota yang diubahsuai',
        AddQuotaRules: 'Tambah peraturan kuota',
        ModifyQuotaRules: 'Ubahsuai peraturan kuota',
        PleaseEnterNumberQuotasModify: 'Sila masukkan bilangan kvot untuk diubahsuai',
        SuccessfullyDeleted: 'Padam dengan berjaya'
    },
  };